import { IProductDetail } from '@/api/types/public';
import GoodsDetailCollapse from '@/components/GoodsDetail/GoodsDetailCollapse';
import { Box } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';

export default function RedemptionNotice({ detail }: { detail: IProductDetail }) {
  const t = useTranslations('account.redeemableItems.RedeemedDetailDialog.redemptionNotice');

  // 使用翻译键对象创建通知文本列表
  let textList = [
    t('notices.oneItemPerOrder'),
    t('notices.pointsNotDeductible'),
    t('notices.noReturnOrExchange'),
  ];

  // 如果不是眼镜类商品，则移除第二条关于镜片的通知
  if (detail.is_glass === 2) {
    textList = textList.filter((_, index) => index !== 1);
  }

  return (
    <GoodsDetailCollapse title={t('title')} defaultOpen>
      <Box className="mb-24">
        {textList.map((text, index) => (
          <p key={text} className="text-14 mt-16 leading-[21px] first:mt-0 font-ir">
            {index + 1}. {text}
          </p>
        ))}
      </Box>
    </GoodsDetailCollapse>
  );
}
